




































import { Component } from 'vue-property-decorator';
import { ProductMigrationModule } from '@/store/Products/ProductMigrationModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductMigrationDetails from '@/components/Products/ProductMigrations/ProductMigrationDetails.vue';
import ProductMigrationLog from '@/components/Products/ProductMigrations/ProductMigrationLog.vue';

@Component({ name: 'ProductMigration', components: { Alert, ProductMigrationDetails, ProductMigrationLog }, metaInfo: { title: 'Product Migrations' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await ProductMigrationModule.getProductMigration(this.$route.params.id);
    }

    get productMigration() {
        return ProductMigrationModule.productMigration;
    }

    get loading() {
        return ProductMigrationModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
